import Cookie from 'js-cookie';

let $ = window.jQuery;
/** Class representing front-end interaction with Etna's Photo Gallery V2 API's */
class PhotoGalleryApiV2 {
  /**
  * Initialize the constructor
  * @param {object} initialState - Include base URL where your photo gallery lives without trailing slash
  */
  constructor(initialState) {
    this.state = {
      url: '',
      version: '/gallery/api/v2',
    };

    this.update(initialState);
    this.checkForUser();
  }

  /**
  * Update State
  * @param {object} newState - pass in new/updated state and this will merge it with the current state of the constructor.
  */
  update(newState) {
    return this.state = Object.assign({}, this.state, newState);
  }

  /**
  * Get All Categories
  * @param {function} callback - function which will pass in all data or error message(s) returned from the API
  * @returns either an error object or an array of objects of the categories.
  */
  getCategories(cb) {
    if (typeof cb === 'function') {
      // the api requires something to be sent, therefore we will send an empty JSON object
      $.ajax({
        type: 'POST',
        url: `${this.state.url}${this.state.version}/categories`,
        contentType: 'application/json',
        data: JSON.stringify({}),
        error: (res) => {
          cb(res);
        },
        success: (res) => {
          cb(res);
        },
      });
    } else {
      console.error('You must provide a callback function for api.getCategories call');
    }
  }

  /**
  * Get all cases by category
  * @param {object} requestObj - Customizable request object. It MUST contain a key of `category_id` with a value that is of type "number". The rest of the params must follow and may be rejected by the API.
  * @param {function} callback - function which will be called and passed the data once the query completes.
  * @returns am Object of the current category which has `case_count` number, `adult` boolean, `cases` array of case objects, `first_returned_position`, which is the sequence value of the case within the category. 
  */
  getCases(requestObj, cb) {
    let validId = typeof requestObj.category_id === 'number';
    let validPathname = typeof requestObj.category_url === 'string';

    if ((validPathname || validId) && typeof cb === 'function') {
      $.ajax({
        type: 'POST',
        url: `${this.state.url}${this.state.version}/gallery/cases`,
        contentType: 'application/json',
        data: JSON.stringify(requestObj),
        error: (res) => {
          cb(res);
        },
        success: (res) => {
          cb(res);
        },
      });
    } else {
      console.error('api.getCases was not passed at least the (category_id || category_url) or the callback function');
    }
  }

  /**
  * Get single case by id.

  @param {number} id - id of requested case number
  @returns via callback and returns the galleries response.
  */
  getCaseById(caseId, cb) {
    if (!caseId) {
      console.error('api.getCaseById: You must pass a case id your first parameter');
    } else {
      $.ajax({
        type: "GET",
        url: `${ this.state.url }${ this.state.version }/gallery/cases/${ caseId }`,
        error: (res) => {
          cb(res);
        },
        success: (res) => {
          cb(res);
        },
      });
    }
  }

  createAccount(newUser, cb) {
    if (!this.state.isBasic) {
      let that = this;

      if (!newUser.email || !newUser.password) {
        console.error('api.createAccount requires email and password to be passed in with an object');
      } else {
        let newUserJson = {
          email: newUser.email,
          password: newUser.password,
        };

        if (newUser.token) {
          newUserJson.token = newUser.token;
        }

        $.ajax({
          type: 'POST',
          url: `${ this.state.url }${ this.state.version }/users`,
          contentType: 'application/json',
          data: JSON.stringify(newUserJson),
          error: (res) => {
            cb(res);
          },
          success: (res) => {
            if (res && res.success) {
              res.email = newUser.email;

              that.updateUserCookie(res);
              cb(res);
            } else {
              cb(res);
            }
          },
        });
      }
    }
  }

  loginToAccount(user, cb) {
    if (!this.state.isBasic) {
      let that = this;

      if (!user.email || !user.password) {
        console.error('api.loginToAccount requires both user email and password');
      } else {
        $.ajax({
          type: 'POST',
          url: `${this.state.url}${this.state.version}/users/authenticate`,
          contentType: 'application/json',
          data: JSON.stringify({
            email: user.email,
            password: user.password
          }),
          error: (res) => {
            cb(res);
          },
          success: (res) => {
            if (res.success) {
              res.email = user.email;
              that.updateUserCookie(res);
              that.getCurrentFavorites();
            }
            cb(res);
          },
        });
      }
    }
  }

  getCurrentFavorites(cb) {
    if (!this.state.isBasic) {
      let that = this;
      let userCookie = Cookie.get('gallery-user');

      if (userCookie) {
        let parsed = JSON.parse(userCookie);

        $.ajax({
          type: 'POST',
          url: `${this.state.url}${this.state.version}/users/favorites`,
          contentType: 'application/json',
          data: JSON.stringify({
            token: parsed.token,
          }),
          error: (res) => {
            cb(res);
          },
          success: (res) => {
            if (res.success) {
              that.updateUserCookie({
                favorites: res.favorites,
              });
            }
            if (typeof cb === 'function') {
              cb(res);
            }
          },
        });
      } else {
        console.error('user undefined');
      }
    }
  }

  toggleFavorite(id, cb) {
    if (!this.state.isBasic) {
      let that = this;
      let userCookie = Cookie.get('gallery-user');

      if (userCookie && parseInt(id, 10)) {
        let parsed = JSON.parse(userCookie);
        let foundCase = false;
        let action = 'add';

        for (var i = 0; i < parsed.favorites.length; i++) {
          if (parsed.favorites[i] === parseInt(id, 10)) {
            foundCase = true;
            action = 'remove';
          }

          if (foundCase) {
            i = parsed.favorites.length;
          }
        }

        $.ajax({
          type: 'POST',
          url: `${this.state.url}${this.state.version}/users/favorites/${ action }`,
          contentType: 'application/json',
          data: JSON.stringify({
            token: parsed.token,
            case_id: parseInt(id, 10),
          }),
          error: (res) => {
            if (typeof cb === 'function') {
              cb(res);  
            }
          },
          success: (res) => {
            if (typeof cb === 'function') {
              cb(res);
            }
            that.getCurrentFavorites();
          },
        });
      }
    }
  }


  checkForUser() {
    if (!this.state.isBasic) {
      let userCookie = Cookie.get('gallery-user');

      if (userCookie) {
        this.getCurrentFavorites();
      }
    }
  }

  /**
  updateUserCookie: gallery-user

  @param {user} object of current user returned by API. 

  @returns object of current user with favorites filter
  */
  updateUserCookie(user, cb) {
    if (!this.state.isBasic) {
      let userCookie = Cookie.get('gallery-user');

      if (user === 'logout') {
        Cookie.remove('gallery-user');

        if (typeof cb === 'function') {
          cb();
        }
      } else if (userCookie) {
        let data = JSON.parse(userCookie);

        if (!data.favorites) {
          data.favorites = [];
        }

        data = Object.assign({}, data, user);

        Cookie.remove('gallery-user');
        Cookie.set('gallery-user', JSON.stringify(data));

        if (typeof cb === 'function') {
          cb(data);
        }
      } else {
        
        if (!user.favorites) {
          user.favorites = [];
        }

        Cookie.set('gallery-user', JSON.stringify(user));

        if (typeof cb === 'function') {
          cb(user);
        }
      }

      $(window).trigger('user-changed');
    }
  }

  createTempUserAndAddFavorite(id) {
    if (!this.state.isBasic) {
      var that = this;
      if (typeof parseInt(id, 10) === 'number') {
        $.ajax({
          type: 'POST',
          url: `${this.state.url}${this.state.version}/users/favorites/add`,
          contentType: 'application/json',
          data: JSON.stringify({
            case_id: parseInt(id, 10),
          }),
          error: (res) => {
            if (typeof cb === 'function') {
              cb(res);  
            }
          },
          success: (res) => {
            if (typeof cb === 'function') {
              cb(res);
            }

            res.favorites = [];
            that.updateUserCookie(res);
            that.getCurrentFavorites();

            // Create an account so you don't lose your favorites list!
          },
        });
      }
    }
  }

  updateUserAccount(userObject, cb) {
    if (!this.state.isBasic) {
      var that = this;

      var response = {
        success: false,
        message: 'No data provided',
      };
      var updatedUser = {};

      if (!userObject.token) {
        response.message = 'There was an error, try logging out and back in.';
        cb(response);
      } else {
        updatedUser.token = userObject.token;

        if (userObject.pw) {
          updatedUser.password = userObject.pw;
        }

        if (userObject.email) {
          updatedUser.email = userObject.email;
        }

        $.ajax({
          type: 'POST',
          url: `${this.state.url}${this.state.version}/users`,
          contentType: 'application/json',
          data: JSON.stringify(updatedUser),
          success: (res) => {
            if (res.success) {
              if (updatedUser.email) {
                response.email = updatedUser.email;
              }
              response.success = true;
              response.message = '';
              
              if (updatedUser.password) {
                delete updatedUser.password;
              } 

              updatedUser.token = res.token;
              that.updateUserCookie(updatedUser);
              cb(response);
            } else {
              response.message = res.error;
              cb(response);
            }
          },
          error: (res) => {
            response.message = res;

            cb(response);
          }
        });
      }
    }
  }
  resetPassword(userObject, cb) {
    if (!this.state.isBasic) {
      var response = {
        success: false,
        message: 'No data provided',
      };
      var updatedUser = {};
      if (!userObject.token) {
        response.message = 'There was an error, try logging out and back in.';
        cb(response);
      } else {
        updatedUser.token = userObject.token;

        if (userObject.pw) {
          updatedUser.password = userObject.pw;
        }

        $.ajax({
          type: 'POST',
          url: `${this.state.url}${this.state.version}/users/password/reset`,
          contentType: 'application/json',
          data: JSON.stringify(updatedUser),
          success: (res) => {
            if (res.status === 'success') {
              response.success = true;
              response.message = '';
              
              if (updatedUser.password) {
                delete updatedUser.password;
              } 

              cb(response);
            } else {
              response.message = res.error;
              cb(response);
            }
          },
          error: (res) => {
            response.message = res;

            cb(response);
          }
        });
      }
    }
  }
  forgotPassword(email, cb) {
    if (!this.state.isBasic) {
      if (email) {
        $.ajax({
          type: 'POST',
          url: `${ this.state.url }${ this.state.version }/users/password/forgot`,
          contentType: 'application/json',
          data: JSON.stringify({ email: email }),
          success: (res) => {
            cb(res);
          },
          fail: (res) => {
            cb(res);
          }
        });
      }
    }
  }
}

window.Cookie = Cookie;
export default PhotoGalleryApiV2;


// WEBPACK FOOTER //
// ./src/scripts/api/PhotoGalleryApiV2.js